module.exports = __webpack_public_path__ + "static/media/1-1-4.3f362d5e.png";